const insertIntoTable = ({ existingRows, subRowsToInsert, path }) => {
  const id = path[0];

  const isBaseCase = path.length === 1;

  if (isBaseCase) {
    return existingRows.map((row, index) => {
      const isMatchedRowWithoutSubRows = index === Number(id);

      if (isMatchedRowWithoutSubRows) {
        if (Array.isArray(row.subRows)) {
          const existingSubRowsIds = row.subRows.map(subRow => subRow.id);

          const newSubRows = subRowsToInsert.filter(
            subRow => !existingSubRowsIds.includes(subRow.id),
          );

          return {
            ...row,
            subRows: [...row.subRows, ...newSubRows],
          };
        }

        return {
          ...row,
          subRows: Array.isArray(row.subRows)
            ? [...row.subRows, ...subRowsToInsert]
            : subRowsToInsert,
        };
      }

      return row;
    });
  }

  return existingRows.map((row, index) => {
    const isMatchedRowWithSubRows = index === Number(id) && row.subRows;

    if (isMatchedRowWithSubRows) {
      const [, ...updatedPath] = path;

      return {
        ...row,
        subRows: insertIntoTable({
          existingRows: row.subRows,
          subRowsToInsert,
          path: updatedPath,
        }),
      };
    }

    return row;
  });
};

export const recursivelyUpdateTable = ({ tableData, childData, id }) => {
  return insertIntoTable({
    existingRows: tableData,
    subRowsToInsert: childData,
    path: id.split('.'),
  });
};
